export interface NotificationIconStyle {
  icon: string;
  wrapClass: string;
  iconClass: string;
}

const ORANGE: NotificationIconStyle = {
  icon: 'ph:clock',
  wrapClass: 'bg-[#FFF1EC]',
  iconClass: 'text-[#FC480D]',
};

const GREEN: NotificationIconStyle = {
  icon: 'ph:check-circle',
  wrapClass: 'bg-[#ECFDF3]',
  iconClass: 'text-[#16A34A]',
};

const BLUE: NotificationIconStyle = {
  icon: 'ph:user',
  wrapClass: 'bg-[#EFF6FF]',
  iconClass: 'text-[#3B82F6]',
};

const ICONS: Record<string, NotificationIconStyle> = {
  mabar_kickoff: { ...ORANGE, icon: 'ph:clock' },
  mabar_payment_reminder: { ...ORANGE, icon: 'ph:credit-card' },
  mabar_payment_success: { ...GREEN, icon: 'ph:check-circle' },
  mabar_unpaid: { ...ORANGE, icon: 'ph:hourglass-medium' },
  mabar_join_approved: { ...BLUE, icon: 'ph:user' },
  mabar_waitlist_promoted: { ...GREEN, icon: 'ph:arrow-up' },
  mabar_leave_approved: { ...BLUE, icon: 'ph:user-minus' },
  booking_hold: { ...ORANGE, icon: 'ph:calendar-blank' },
  booking_session_1h: { ...ORANGE, icon: 'ph:calendar-blank' },
  booking_confirmed: { ...ORANGE, icon: 'ph:credit-card' },
  community_open_list: { ...BLUE, icon: 'ph:megaphone' },
  community_member_reminder: { ...BLUE, icon: 'ph:bell' },
};

export function getNotificationIcon(type: string): NotificationIconStyle {
  return ICONS[type] ?? ORANGE;
}

export function getNotificationActionIcon(label: string): string {
  if (label === 'Lihat lokasi') return 'ph:map-pin';
  if (label === 'Bayar') return 'ph:money';
  if (label === 'Gabung') return 'ph:user-plus';
  return 'ph:arrow-right';
}
